import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import Providers from "./providers";
import Router from "./routes";

import "./assets/scss/line-awesome/line-awesome.scss";
import "./assets/scss/styles.scss";

// Put any other imports below so that CSS from your
// components takes precedence over default styles.

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Providers>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </Providers>
  </React.StrictMode>
);
